import React from 'react';
import { QrCodeIcon, DalanyKurdishTextLogo } from './icons';

const Footer: React.FC = () => {
    return (
        <tfoot>
            <tr>
                <td>
                    <div className="pt-20 pb-2 text-xs">
                        <div className="flex justify-between items-end mb-8">
                            <div className="flex items-center gap-4">
                                <QrCodeIcon className="h-16 w-16 text-slate-400" />
                                <div>
                                    <p className="font-bold text-slate-700 text-sm">Scan to Verify Report</p>
                                    <p className="text-slate-500 text-xs">Verify the authenticity of this report online.</p>
                                </div>
                            </div>
                            <div className="text-center">
                                <div className="w-48 h-12 border-b-2 border-slate-300 mb-2"></div>
                                <p className="font-semibold text-slate-700 text-sm">Reviewed By</p>
                            </div>
                        </div>

                        <hr className="mb-6 border-slate-200/80" />
                        
                        <div className="flex justify-between items-center mb-6">
                             <div className="page-number font-sans font-semibold text-slate-600 text-sm"></div>
                            <h3 className="text-base font-rabar-bold text-slate-800" dir="rtl">
                                ناونیشانی تاقیگەکانمان
                            </h3>
                        </div>

                        <div className="grid grid-cols-2 gap-x-8 gap-y-5 text-sm font-rabar">
                           {/* Branch 1 */}
                            <div className="leading-relaxed text-right">
                                <div className="flex items-center justify-start gap-2" dir="rtl">
                                    <DalanyKurdishTextLogo className="h-3.5 text-slate-800" />
                                    <span className="font-rabar-bold text-slate-800">٤٠ مەتری</span>
                                </div>
                                <p className="text-slate-500" dir="rtl">هەولێر، شەقامی ٤٠ مەتری، چواریانی کۆک، بەرامبەر باخچەی برایەتی</p>
                                <p className="font-sans font-semibold text-brand pt-1" dir="ltr">0750 388 7447</p>
                            </div>
                            {/* Branch 2 */}
                            <div className="leading-relaxed text-right">
                                <div className="flex items-center justify-start gap-2" dir="rtl">
                                    <DalanyKurdishTextLogo className="h-3.5 text-slate-800" />
                                    <span className="font-rabar-bold text-slate-800">ڕزگاری</span>
                                </div>
                                <p className="text-slate-500" dir="rtl">هەولێر، شەقامی ١٠٠ مەتری، بەرامبەر نەخۆشخانەی ڕزگاری</p>
                                <p className="font-sans font-semibold text-brand pt-1" dir="ltr">0750 519 4008</p>
                            </div>
                            {/* Branch 3 */}
                            <div className="leading-relaxed text-right">
                                <div className="flex items-center justify-start gap-2" dir="rtl">
                                    <DalanyKurdishTextLogo className="h-3.5 text-slate-800" />
                                    <span className="font-rabar-bold text-slate-800">خەبات</span>
                                </div>
                                <p className="text-slate-500" dir="rtl">قەزای خەبات، شەقامی ناوبازاڕ، تەنیشت قوتابخانەی ئادۆمەند</p>
                                <p className="font-sans font-semibold text-brand pt-1" dir="ltr">0750 603 4008</p>
                            </div>
                            {/* Branch 4 */}
                            <div className="leading-relaxed text-right">
                                <div className="flex items-center justify-start gap-2" dir="rtl">
                                    <DalanyKurdishTextLogo className="h-3.5 text-slate-800" />
                                    <span className="font-rabar-bold text-slate-800">ڕانیە</span>
                                </div>
                                <p className="text-slate-500" dir="rtl">قەزای ڕانیە، شەقامی ناو بازاڕ، بەرامبەر مزگەوتی ناحیەخان</p>
                                <p className="font-sans font-semibold text-brand pt-1" dir="ltr">0750 214 4008</p>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </tfoot>
    );
};

export default Footer;